// extracted by mini-css-extract-plugin
module.exports = {"block":"Accreditation_block__19XvN","title":"Accreditation_title__1-ttP","text":"Accreditation_text__3-dw1"};